export default __webpack_public_path__ + "static/media/potassium.bbd4e715.png";